export default __webpack_public_path__ + "static/char-s-49-zh-Hant-72ba2974595d169eb611e5fa337768e5.webp";